import React, { useState } from "react";
import DOMPurify from "dompurify";
import "./login-payment.m.css";
import { createUrl } from "../../../utils/createurl";

const LoginPaymentBase = props => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const links=createUrl("forgotpassword");
  const handleEmailChange = e => {
    const { value } = e.target;
    const nameValue = DOMPurify.sanitize(value);
    setEmail(nameValue);
  };
  const handlePasswordChange = e => {
    const { value } = e.target;
    const passwordValue = DOMPurify.sanitize(value);
    setPassword(passwordValue);
  };
  // Initialize a boolean state
  const [passwordShown, setPasswordShown] = useState(false);
  const [passwordIcon, setPasswordIcon] = useState(true);
  // Password toggle handler
  const togglePassword = () => {
    // When the handler is invoked
    // inverse the boolean state of passwordShown
    setPasswordShown(!passwordShown);
    setPasswordIcon(!passwordIcon);
  };

  return (
    <React.Fragment>
      <div id="loginBox" className="qt-login-form" styleName="qt-login-form">
        <h2 className="kirjaudu-header" styleName="kirjaudu-header">
          Kirjaudu sisään
        </h2>
        <form styleName="login-form" action="/tulo/authenticate" method="post">
          <div className="input-group">
            <div className="input-field">
              <p className="kayttajatunnus" styleName="kayttajatunnus">
                Käyttäjätunnus
              </p>
              <input
                value={email}
                type="email"
                name="email"
                styleName="payment-input"
                required
                onChange={e => handleEmailChange(e)}
              />
            </div>
            <div className="input-field">
              <p className="kayttajatunnus" styleName="kayttajatunnus">
                Salasana
              </p>
              <div styleName="passWd" className="passWd">
                <input
                  value={password}
                  styleName="paywall-login-passWd"
                  //type="password"
                  type={passwordShown ? "text" : "password"}
                  name="password"
                  required
                  onChange={e => handlePasswordChange(e)}
                />
                <a aria-label="Näytä salasana" styleName="show-passWd" role="button" onClick={togglePassword}><i styleName="eye-icon" className={`${passwordIcon ? "ri-eye-line" : "ri-eye-off-line"}`}></i></a>
              </div>
            </div>
          </div>
          <a href={links} styleName="forgot-link">
            Unohtuiko salasana?
          </a>
          <button type="submit" styleName="sisaan">
            <span>Kirjaudu sisään</span>
          </button>
        </form>
      </div>
    </React.Fragment>
  );
};

export { LoginPaymentBase };
